<template>
    <div class="app-left">
        <appLogo></appLogo>
        <el-menu
                ref="menu"
                default-active=""
                class="el-menu-vertical-demo"
                @open="handleOpen"
                @close="handleClose"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b">
            <el-submenu v-for="menuItem in this.menus" @click="menuItemClick(menuItem)" :key="menuItem.id" :index="menuItem.id">
                <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>{{menuItem.name}}</span>
                </template>
                <el-menu-item v-for="menuItem1 in menuItem.children" @click="menuItemClick(menuItem1)" :key="menuItem1.id" :index="menuItem1.id">
                    {{menuItem1.name}}
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import appLogo from './_logo'
    export default {
        data () {
            return {
                menus: [],
                menuData: storageKit.getJson(jsCtx.localConstant.menu),
                menu: '',
                pid: '',
                routePath: '',
                routeUrl: '',
                routeName: '',
                tag: {},
                keyData: ''
            }
        },
        components: {
          appLogo
        },
        props: {
            theme: String
        },
        watch: {
            $route () {
              //this.menuSelect()
            },
        },
        mounted () {
            //this.menuSelect();
            this.renderMenuDataForElementUI();
            // console.log(this.menuData[0].children);
        },
        computed: {
            ...mapState(['siderCollapsed'])
        },
        methods: {
            menuItemClick(item){
                console.log(item);
                this.$router.push(item.url);
            },
            handleOpen(key, keyPath) {
                console.log(key, keyPath);

                // this.$refs.menu.select(keyPath);
                this.$router.push(keyPath);
            },
            handleClose(key, keyPath) {
                console.log(key, keyPath);
            },
            menuSelect () {
                if (this.$route.name) {
                    this.$refs.menu.select(this.$route.name)
                }
            },
            renderMenuDataForElementUI(){
                setTimeout(()=>{
                    let menusList = storageKit.getJson(jsCtx.localConstant.menu);
                    if(menusList){
                        if(menusList[0].children.length<0) return;
                        const pom = this.filterAsyncRouter(menusList[0].children);
                        this.menus = pom;
                    }
                },200);
            },
            filterAsyncRouter(asyncRouterMap) { //遍历后台传来的路由字符串，转换为组件对象  LogKit.log(res)
                if(!asyncRouterMap.length) return;
                const accessedRouters = asyncRouterMap.filter(res => {
                    if(res.name !== null && res.name !=='' && res.name!==undefined && res.name!=='undefined'){
                        if(res.url){
                            if((res.url).indexOf('.vue')){
                                res.url=res.url.replace(/.vue/g,'');
                                this.$set(res,'key',res.url);
                            }
                            // else{
                            //    this.$set(res,'key',res.url);
                            // }
                            //  this.$set(res,'key',res.url);
                        } else {
                            this.$set(res,'key', res.id);
                        }
                        this.$set(res,'title',res.name);
                    }
                    if(res.children && res.children.length) {
                        res.children = this.filterAsyncRouter(res.children)
                    }
                    return true;
                });
                return accessedRouters;
            },
            trigger (data) {
                if (data.children.length > 0) return;
                this.$router.push({path:'/'+data.key})
            },
            hideMenu () {
              this.$store.commit('updateSiderCollapse', true)
            }
        }
    }
</script>
<style lang="less" scoped>
    .app-left{
        overflow: hidden;
        .el-menu{
            height: calc(100vh - 60px);
            border-right: none;
        }
        .el-menu::-webkit-scrollbar{
            width: 0px;
        }
    }
</style>
